// extracted by mini-css-extract-plugin
export default {"sourceText":"Qh6W1gR5pcYDNBPqL3vF"};